<div class="border border-[#E4E4E4] rounded-lg py-3 px-4 flex justify-between">
    <p class="text-[#96A0B5] text-[13px] font-medium">{{ label }}</p>
    <p class="text-[#25282D] text-[13px] font-medium" *ngIf="!isStatus">{{ value }}</p>
    <p class="text-[#25282D] text-[13px] font-medium" *ngIf="isStatus">
        <span class="table-label" [ngClass]="{'active': value === 'Active', 'inActive': value === 'In Active'}">{{ value }}</span>
    </p>
</div>
